// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEeContributionResponseDto
 */
export interface IEeContributionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IEeContributionResponseDto
     */
    employee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IEeContributionResponseDto
     */
    hold_days?: number;
}

/**
 * Check if a given object implements the IEeContributionResponseDto interface.
 */
export function instanceOfIEeContributionResponseDto(value: object): value is IEeContributionResponseDto {
    return true;
}

export function IEeContributionResponseDtoFromJSON(json: any): IEeContributionResponseDto {
    return IEeContributionResponseDtoFromJSONTyped(json, false);
}

export function IEeContributionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEeContributionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_contribution_amount': json['employee_contribution_amount'] == null ? undefined : json['employee_contribution_amount'],
        'hold_days': json['hold_days'] == null ? undefined : json['hold_days'],
    };
}

export function IEeContributionResponseDtoToJSON(json: any): IEeContributionResponseDto {
    return IEeContributionResponseDtoToJSONTyped(json, false);
}

export function IEeContributionResponseDtoToJSONTyped(value?: IEeContributionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_contribution_amount': value['employee_contribution_amount'],
        'hold_days': value['hold_days'],
    };
}

